export const saveB2CMeetingData = data => ({
    type: 'SAVE_B2C_MEETING_DATA',
    data
});
